import React from 'react';
import {Route, Redirect} from 'react-router-dom';


//https://tylermcginnis.com/react-router-protected-routes-authentication/
export default function AuthorizedRoute({

  component: Component,
  authenticated,
  ...rest
})  {

  return (
    <Route
      {...rest}
      render={props =>
        authenticated === true ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}